import { IApplyAuthInjectable } from '@src/slide/application/service/apply-auth-service/inject/interface';

export default class ApplyAuthInjectable implements IApplyAuthInjectable {
    public getApplyCGI(): string {
        return 'cgi-bin/online_docs/auth_apply/check';
    }

    public shouldDisableGuideBtns(): boolean {
        return false;
    }
}
